import React from 'react'
import HeroSection from './HeroSection';
import FutureTechPage from './futuretechpage';
import CukPage from './cuk_conference';
import TechServicesShowcase from '../business/teschstack';
import BuildWinArena from './buildwinpage';


function HomePage() {
  return (
    <> 
    <div>

        <HeroSection/>
        <CukPage/>
        <FutureTechPage/>
        <TechServicesShowcase/>
        <BuildWinArena/>

      
    </div>
    
    </>
     
  );
}

export default HomePage;


